<template>
  <section class="section mydata">
    <div class="wrap">
      <div class="flower-sway">
        <!-- <img src="/images/checklist/carnation.svg" /> -->
        <ClientOnly>
          <Vue3Lottie :animation-data="flowerJSON" :speed="1" :loop="true" :auto-play="true" />
        </ClientOnly>
      </div>

      <div class="tabs">
        <div
          class="tab"
          :class="{
            active: type === 'month',
          }"
          @click="onTabClick('month')"
        >
          {{ $t('이번달') }}
        </div>
        <div
          class="tab"
          :class="{
            active: type === 'total',
          }"
          @click="onTabClick('total')"
        >
          {{ $t('전체') }}
        </div>
      </div>

      <div
        v-if="type === 'month'"
        class="total-text"
        v-html="
          $t('이번달에spanclasscolor{0}일{1}회span참여했어요')
            .replace('{0}', myStatistics.engagementDays.toString())
            .replace('{1}', myStatistics.engagementCount.toString())
        "
      />
      <div
        v-if="type === 'total'"
        class="total-text"
        v-html="
          $t('전체spanclasscolor{0}일{1}회span참여했어요')
            .replace('{0}', myStatistics.engagementDays.toString())
            .replace('{1}', myStatistics.engagementCount.toString())
        "
      />

      <!-- List -->
      <ul class="check-counts">
        <!-- 01 greeting -->
        <li class="list-item">
          <div class="item greeting">
            <div class="item-icon" />
            <div class="text">
              <div class="title">
                {{ $t('인사') }}
              </div>
              <div class="count">
                {{ myStatistics.countPerItem[1] ?? 0 }}
              </div>
            </div>
          </div>
        </li>
        <!-- 02 thanks -->
        <li class="list-item">
          <div class="item thanks">
            <div class="item-icon" />
            <div class="text">
              <div class="title">
                {{ $t('감사') }}
              </div>
              <div class="count">
                {{ myStatistics.countPerItem[2] ?? 0 }}
              </div>
            </div>
          </div>
        </li>
        <!-- 03 apology -->
        <li class="list-item">
          <div class="item apology">
            <div class="item-icon" />
            <div class="text">
              <div class="title">
                {{ $t('사과') }}
              </div>
              <div class="count">
                {{ myStatistics.countPerItem[3] ?? 0 }}
              </div>
            </div>
          </div>
        </li>
        <!-- 04 tolerance -->
        <li class="list-item">
          <div class="item tolerance">
            <div class="item-icon" />
            <div class="text">
              <div class="title">
                {{ $t('포용') }}
              </div>
              <div class="count">
                {{ myStatistics.countPerItem[4] ?? 0 }}
              </div>
            </div>
          </div>
        </li>
        <!-- 05 yield -->
        <li class="list-item">
          <div class="item yield">
            <div class="item-icon" />
            <div class="text">
              <div class="title">
                {{ $t('양보') }}
              </div>
              <div class="count">
                {{ myStatistics.countPerItem[5] ?? 0 }}
              </div>
            </div>
          </div>
        </li>
        <!-- 06 esteem -->
        <li class="list-item">
          <div class="item esteem">
            <div class="item-icon" />
            <div class="text">
              <div class="title">
                {{ $t('존중') }}
              </div>
              <div class="count">
                {{ myStatistics.countPerItem[6] ?? 0 }}
              </div>
            </div>
          </div>
        </li>
        <!-- 07 cheerup -->
        <li class="list-item">
          <div class="item cheerup">
            <div class="item-icon" />
            <div class="text">
              <div class="title">
                {{ $t('응원') }}
              </div>
              <div class="count">
                {{ myStatistics.countPerItem[7] ?? 0 }}
              </div>
            </div>
          </div>
        </li>
        <!-- 08 consideration -->
        <li class="list-item">
          <div class="item consideration">
            <div class="item-icon" />
            <div class="text">
              <div class="title">
                {{ $t('배려') }}
              </div>
              <div class="count">
                {{ myStatistics.countPerItem[8] ?? 0 }}
              </div>
            </div>
          </div>
        </li>
        <!-- 09 compliment -->
        <li class="list-item">
          <div class="item compliment">
            <div class="item-icon" />
            <div class="text">
              <div class="title">
                {{ $t('칭찬') }}
              </div>
              <div class="count">
                {{ myStatistics.countPerItem[9] ?? 0 }}
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </section>
</template>

<script setup lang="ts">
// lottie
import { Vue3Lottie } from 'vue3-lottie'
import flowerJSON from '@/assets/lotties/flower.json'

defineProps<{
  myStatistics: HmlMyCampaignStatisticsModel
  type: 'month' | 'total'
}>()

const emits = defineEmits<{
  (event: 'onTabClick', info: { type: 'month' | 'total' }): void
}>()

function onTabClick(type: 'month' | 'total') {
  emits('onTabClick', { type })
}
</script>
